import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getDifferenceWithPrecision, showMetric } from 'utils'

import useStyles from './useStyles'

interface Props {
  color?: string
  className?: string
  hidePercent?: boolean
  label?: string
  metric?: string
  percent?: number | null
  percentDifference?: {
    type: string
    value: string
  }
  showArrow?: boolean
  suffix?: string
  value?: number | string
}

const defaultPercentDifference = {
  type: '',
  value: '',
}

function MathAbsValue(value: string) {
  if (value.length > 2) {
    return value.replace(/^-/, '')
  }

  return value
}

function InfoElement({
  className = '',
  color = '',
  hidePercent = false,
  label = '',
  metric,
  percent,
  percentDifference = defaultPercentDifference,
  suffix = '%',
  value,
}: Props) {
  const classes = useStyles({ color })
  const { t: translate } = useTranslation()
  const differenceWithPrecision = getDifferenceWithPrecision({
    handleNullCase: true,
    number: percent,
    precision: 0,
    suffix,
    translate,
  })
  const percentDiff = percent ? differenceWithPrecision : percentDifference

  return (
    <span className={className ? `info ${classes.root} ${className}` : `info ${classes.root}`}>
      <span className="info_label">{label && label.length > 0 && `${label}:`}</span>
      {(value || value === 0) && <span className="info_value">{showMetric(value, metric)}</span>}
      {!hidePercent && (
        <span className={classNames('info_percent-difference', `is-${percentDiff.type}`)}>{MathAbsValue(percentDiff.value)}</span>
      )}
    </span>
  )
}

export default InfoElement
